import { render, staticRenderFns } from "./latelyFile.vue?vue&type=template&id=1c99c4b3&scoped=true"
import script from "./latelyFile.vue?vue&type=script&lang=js"
export * from "./latelyFile.vue?vue&type=script&lang=js"
import style0 from "./latelyFile.vue?vue&type=style&index=0&id=1c99c4b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c99c4b3",
  null
  
)

export default component.exports